/**
 * Modals.js
 * Written by: Alex Kasemir
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import { ModalWrapper } from '@minerva-analytics/pantheon';

import CustomModal from 'components/CustomModal';

import modalSelectors from 'store/modal/selectors';
import modalActions from 'store/modal/actions';
import modals from 'root/modals';

import event from 'utils/event';

class Modals extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  onModalClose = () => {
    const { modal, destroyModal } = this.props;

    event(`close-modal`, [`click`, `close-modal`, `${modal.key}`]);

    destroyModal({
      id: modal.id,
    });
  }

  render() {
    const { modal } = this.props;

    return (
      <div>
        { modal
          ? <ModalWrapper
            closeModal={ this.onModalClose }
            headerText={ modal.extraProps.header }
            isOpen
            backdropClosesModal
          >
            <CustomModal
              header={ modal.extraProps.header }
              onCancel={ this.onModalClose }
              body={ modals[modal.key].component(modal, this.onModalClose) }
              hideCloseButton={ modals[modal.key].hideCloseButton }
            />
          </ModalWrapper>
          : null
        }
      </div>
    );
  }
}

Modals.propTypes = {
  modal: PropTypes.object,
  destroyModal: PropTypes.func.isRequired,
};

Modals.contextTypes = {
  store: PropTypes.object,
  storeSubscription: PropTypes.object,
  router: PropTypes.object,
};

export default connect((state) => {
  return {
    modal: modalSelectors.first(state),
  };
}, {
  destroyModal: modalActions.destroyModal,
})(withRouter(Modals));
